import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  Grid,
  Stack,
  Breadcrumbs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MotionCard = motion(Card);

const primary      = "#8B1A1A";
const primaryMid   = "#C0392B";
const primaryLight = "rgba(139,26,26,0.07)";
const primaryBorder= "rgba(139,26,26,0.22)";

const tarifas = [
  { label: "Extranjero",     col1: "US$600.00 / QTZ 4,800.00", col2: "US$650.00 / QTZ 5,200.00", col3: "US$700.00 / QTZ 5,600.00" },
  { label: "Nacional",       col1: "US$575.00 / QTZ 4,600.00", col2: "US$600.00 / QTZ 4,800.00", col3: "US$625.00 / QTZ 5,000.00" },
  { label: "Acompañante*",   col1: "US$200.00 / QTZ 1,600.00", col2: "US$200.00 / QTZ 1,600.00", col3: "US$200.00 / QTZ 1,600.00" },
];

const includes = [
  "Conferencias magistrales y paneles",
  "Refrigerios a.m. y p.m.",
  "Almuerzos",
  "Acceso al área de stands",
  "Certificado digital",
  "Acceso a plataforma de Networking",
];

export default function Tarifas() {
  return (
    <Stack
      spacing={0}
      alignItems="center"
      sx={{ background: "#f4f5f7", width: "100%", minHeight: "100vh" }}
    >
      {/* ── BREADCRUMB ── */}
      <Box sx={{ width: "100%", pt: 2.5, pb: 1, px: 3, background: "#f4f5f7", display: "flex", justifyContent: "center" }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 15 }}>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              color: "inherit",
              textDecoration: "none",
              fontSize: 15,
            }}
          >
            <HomeIcon sx={{ fontSize: 18 }} />
            Inicio
          </Link>
          <Typography
            sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: 15, color: primary }}
          >
            <AttachMoneyIcon sx={{ fontSize: 18 }} />
            Tarifas
          </Typography>
        </Breadcrumbs>
      </Box>

      {/* ── MAIN CONTENT ── */}
      <Box sx={{ width: "100%", py: 6 }}>
        <Container maxWidth="md">

          {/* HEADER */}
          <Box mb={5}>
            <Typography
              variant="overline"
              sx={{ color: primary, fontWeight: 600, letterSpacing: 2, fontSize: 11 }}
            >
              XI Congreso Latinoamericano de Riesgos
            </Typography>
            <Typography variant="h4" fontWeight={700} sx={{ color: primary, mt: 0.5 }}>
              TARIFAS CLAR 2026
            </Typography>
            <Box sx={{ width: 52, height: 3, background: primary, borderRadius: 2, mt: 1.5, mb: 2 }} />
          </Box>

          {/* INFO CARD */}
          <MotionCard
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
            sx={{
              borderRadius: 3,
              p: "1.25rem 1.5rem",
              mb: 4,
              background: "#fff",
              border: `1px solid ${primaryBorder}`,
              borderLeft: `4px solid ${primary}`,
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
              boxShadow: "none",
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                background: primaryLight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <AutoAwesomeIcon sx={{ color: primary, fontSize: 20 }} />
            </Box>
            <Box>
              <Typography
                variant="overline"
                sx={{ color: primaryMid, fontWeight: 600, letterSpacing: 1.5, fontSize: 10 }}
              >
                Evento
              </Typography>
              <Typography variant="h6" fontWeight={700} sx={{ color: primary, lineHeight: 1.3 }}>
                Hotel Casa Santo Domingo — Antigua Guatemala
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", mt: 0.25 }}>
                Jueves 08 y viernes 09 de octubre 2026 · 08:30 – 17:30
              </Typography>
            </Box>
          </MotionCard>

          {/* TABLA DE TARIFAS */}
          <Typography
            variant="overline"
            sx={{ color: primary, fontWeight: 600, letterSpacing: 2, fontSize: 11, display: "block", mb: 1.5 }}
          >
            Inscripción
          </Typography>

          <MotionCard
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              border: "1px solid #ddd",
              boxShadow: "none",
              mb: 1,
            }}
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ background: "#fff", borderBottom: "none", width: "28%" }} />
                    <TableCell
                      align="center"
                      sx={{
                        background: primary,
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        py: 2,
                        lineHeight: 1.3,
                      }}
                    >
                      Hasta el<br />15/07/2026
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        background: primaryMid,
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        py: 2,
                        lineHeight: 1.3,
                      }}
                    >
                      Hasta el<br />31/08/2026
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        background: "#6B1212",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        py: 2,
                        lineHeight: 1.3,
                      }}
                    >
                      Hasta el<br />día del evento
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tarifas.map((row, i) => (
                    <TableRow
                      key={i}
                      sx={{
                        background: i % 2 === 0 ? primaryLight : "#fff",
                        "&:last-child td": { border: 0 },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 600, fontSize: "0.95rem", color: "#2d2d2d", py: 2.5, pl: 3 }}>
                        {row.label}
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 600, fontSize: "1rem", color: primary, py: 2.5 }}>
                        {row.col1}
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 600, fontSize: "1rem", color: primary, py: 2.5 }}>
                        {row.col2}
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 600, fontSize: "1rem", color: primary, py: 2.5 }}>
                        {row.col3}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </MotionCard>

          <Box display="flex" justifyContent="space-between" mb={5} flexWrap="wrap" gap={1}>
            <Typography variant="caption" sx={{ color: "#999", fontStyle: "italic" }}>
              *Aplica para eventos sociales
            </Typography>
            <Typography variant="caption" sx={{ color: "#999", fontStyle: "italic" }}>
              IVA incluido · Consulta por tarifas especiales de 3 ó más personas
            </Typography>
          </Box>

          {/* INCLUYE */}
          <Typography
            variant="overline"
            sx={{ color: primary, fontWeight: 600, letterSpacing: 2, fontSize: 11, display: "block", mb: 1.5 }}
          >
            La inscripción incluye
          </Typography>

          <Grid container spacing={2}>
            {includes.map((item, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <MotionCard
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: i * 0.07 }}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    height: "100%",
                    background: "#fff",
                    border: "1px solid #e8e8e8",
                    boxShadow: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: 2,
                      background: primaryLight,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: primary, fontSize: 18 }} />
                  </Box>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#333", lineHeight: 1.3 }}>
                    {item}
                  </Typography>
                </MotionCard>
              </Grid>
            ))}
          </Grid>

        </Container>
      </Box>
    </Stack>
  );
}
